import React, { useEffect, useState } from 'react';
import './Refunds.css';
import Header from '../common/Header';
import httpService from '../../services/HttpService';
import { formattedPrice } from '../../utils/priceFormatter';
import { Link } from 'react-router-dom';

const Refunds = () => {
    const [refunds, setRefunds] = useState([]);

    useEffect(() => {
        const fetchRefunds = async () => {
            try {
                const response = await httpService.get("/refunds");
                const data = await response.json();
                setRefunds(data);
            } catch (error) {
                console.error("Error fetching refunds:", error);
            }
        };

        fetchRefunds();
    }, []);

    
    return (
        <>
            <Header />
            <main className="refund-main">
                <div>
                    <div className="refund-title">Возвраты</div>
                    {refunds.length === 0 ? (
                        <p>Нет возвраты</p>
                    ) : (
                        <div>
                            {refunds.map((refund) => {
                                return (
                                    <div key={refund.id} className="order-item">
                                        <div className="order-status bold">
                                            #{refund.id} Статус: {refund.status}
                                        </div>

                                        <div className="order-details">
                                            <p>Причина: {refund.reason}</p>
                                        </div>
                                        <div className="order-product">
                                            <Link className="link" to={`/product/${refund.product.id}`}>
                                                <img
                                                    src={refund.product.main_image.link}
                                                    alt={refund.product.name}
                                                    className="refund-item-image"
                                                />
                                            </Link>
                                            <div className="refund-item-middle">
                                                <p className="cart-item-name">{refund.product.name}</p>
                                                <p className="cart-item-brand-name">Бренд #{refund.product.brand_id}</p>
                                                <p className="cart-item-size">Size: {refund.product.size}</p>
                                                <p className="order-size">{formattedPrice(refund.product.price, null, refund.product.sale)} {refund.product.actual_price} &#8381;</p>
                                                <a href="https://t.me/zametna_com" className="contact-support"
                                                   target="_blank" rel="noopener noreferrer">
                                                    Contact support
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </main>
        </>
    );
};

export default Refunds;